/* Plug & Play native theme. Vanilla JS, no dependencies. */
(() => {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = () => matchMedia("(prefers-reduced-motion: reduce)").matches;
  const root = (window.PP && window.PP.routes && window.PP.routes.root) || "/";

  /* ---------------- body scroll lock ---------------- */
  let locks = 0;
  const lock = () => { if (locks++ === 0) document.documentElement.classList.add("pp-lock"); };
  const unlock = () => { locks = Math.max(0, locks - 1); if (!locks) document.documentElement.classList.remove("pp-lock"); };

  /* ---------------- cart ---------------- */
  const drawer = () => $("[data-cart-drawer]");
  let lastFocus = null;
  function setCount(count, total) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.hidden = !count;
      el.style.transform = "scale(1.45)";
      setTimeout(() => (el.style.transform = ""), 450);
    });
    $$("[data-cart-open]").forEach((b) => b.setAttribute("aria-label", `סל הקניות, ${count} פריטים, סך הכל ${total || ""}`));
  }
  function swapCart(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const fresh = $("[data-cart-drawer-content]", doc);
    const current = $("[data-cart-drawer-content]");
    if (fresh && current) {
      current.replaceWith(fresh);
      setCount(Number(fresh.dataset.count || 0), fresh.dataset.total);
      fillExtras(true);
      bindWishlist(fresh);
    }
  }
  async function refreshCart() {
    const r = await fetch(`${root}?sections=cart-drawer`);
    const data = await r.json();
    if (data["cart-drawer"]) swapCart(data["cart-drawer"]);
  }
  let extrasHtml = null;
  async function fillExtras(force) {
    const slot = $("[data-cart-extras]");
    if (!slot) return;
    if (force || extrasHtml === null) {
      try {
        const r = await fetch(`${root}?sections=cart-extras`);
        const data = await r.json();
        const doc = new DOMParser().parseFromString(data["cart-extras"] || "", "text/html");
        const sec = $(".cart-extras", doc);
        extrasHtml = sec ? sec.outerHTML : "";
      } catch (_) { extrasHtml = ""; }
    }
    $$("[data-cart-extras]").forEach((s) => (s.innerHTML = extrasHtml));
    document.dispatchEvent(new CustomEvent("pp:tiles"));
  }
  function openCart() {
    const d = drawer();
    fillExtras(false);
    if (!d || !d.hidden) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    lock();
    setTimeout(() => $(".cart-drawer-close", d)?.focus(), 30);
  }
  function closeCart() {
    const d = drawer();
    if (!d || d.hidden) return;
    d.hidden = true;
    unlock();
    lastFocus?.focus?.();
  }
  async function addToCart(id, quantity = 1) {
    const r = await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }], sections: "cart-drawer", sections_url: location.pathname }),
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || "add failed");
    if (data.sections && data.sections["cart-drawer"]) swapCart(data.sections["cart-drawer"]);
    else await refreshCart();
    openCart();
    return data;
  }
  async function changeLine(key, quantity) {
    const r = await fetch(`${root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity, sections: "cart-drawer", sections_url: location.pathname }),
    });
    const data = await r.json();
    if (data.sections && data.sections["cart-drawer"]) swapCart(data.sections["cart-drawer"]);
    else await refreshCart();
  }
  document.addEventListener("click", (e) => {
    const t = e.target;
    if (t.closest("[data-cart-open]")) { e.preventDefault(); openCart(); return; }
    if (t.closest("[data-cart-close]")) { if (t.closest("a[href]")) closeCart(); else { e.preventDefault(); closeCart(); } return; }
    const line = t.closest("[data-line-key]");
    if (line) { e.preventDefault(); line.disabled = true; changeLine(line.dataset.lineKey, Number(line.dataset.qty)); return; }
    const coupon = t.closest("[data-coupon-toggle]");
    if (coupon) {
      const box = coupon.closest("[data-coupon]");
      const open = !box.classList.contains("is-open");
      box.classList.toggle("is-open", open);
      coupon.setAttribute("aria-expanded", open);
      $(".cart-coupon-reveal", box).setAttribute("aria-hidden", !open);
      $$("input,button[type=submit]", box).forEach((el) => (el.tabIndex = open ? 0 : -1));
    }
  });
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("[data-coupon-form]");
    if (!form) return;
    e.preventDefault();
    const code = form.discount.value.trim();
    const msg = $("[data-coupon-msg]", form);
    msg.hidden = false;
    if (!code) { msg.textContent = "יש להזין קוד קופון"; return; }
    msg.textContent = "הקוד ייבדק ויחושב בקופה";
    const checkout = $(".cart-checkout-button");
    if (checkout) checkout.href = `${root}checkout?discount=${encodeURIComponent(code)}`;
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    closeCart();
    closeMenu();
    closeSearch();
    closeSizes();
    closeGuide();
    closeFilters();
    const acc = $("[data-account-panel]");
    if (acc && !acc.hidden) toggleAccount(false);
  });

  /* ---------------- header: menu, search, account ---------------- */
  function openMenu() { const m = $("[data-menu]"); if (!m || !m.hidden) return; m.hidden = false; lock(); $("[data-menu-open]")?.setAttribute("aria-expanded", "true"); setTimeout(() => $(".site-menu-tab", m)?.focus(), 30); }
  function closeMenu() { const m = $("[data-menu]"); if (!m || m.hidden) return; m.hidden = true; unlock(); const b = $("[data-menu-open]"); b?.setAttribute("aria-expanded", "false"); b?.focus(); }
  function openSearch() { const s = $("[data-search]"); if (!s || !s.hidden) return; s.hidden = false; lock(); setTimeout(() => $("[data-search-input]", s)?.focus(), 30); }
  function closeSearch() { const s = $("[data-search]"); if (!s || s.hidden) return; s.hidden = true; unlock(); }
  function toggleAccount(force) {
    const p = $("[data-account-panel]");
    const b = $("[data-account-toggle]");
    if (!p) return;
    const open = force ?? p.hidden;
    p.hidden = !open;
    b.setAttribute("aria-expanded", open);
  }
  document.addEventListener("click", (e) => {
    const t = e.target;
    if (t.closest("[data-menu-open]")) return openMenu();
    if (t.closest("[data-menu-close]")) return closeMenu();
    const g = t.closest("[data-menu-group]");
    if (g) {
      const open = g.getAttribute("aria-expanded") !== "true";
      $$("[data-menu-group]").forEach((o) => { o.setAttribute("aria-expanded", "false"); o.nextElementSibling.hidden = true; $(".site-menu-expand-icon", o).textContent = "+"; });
      g.setAttribute("aria-expanded", open);
      g.nextElementSibling.hidden = !open;
      $(".site-menu-expand-icon", g).textContent = open ? "−" : "+";
      return;
    }
    if (t.closest("[data-search-open]")) return openSearch();
    if (t.closest("[data-search-close]")) return closeSearch();
    if (t.closest("[data-account-toggle]")) return toggleAccount();
    if (!t.closest("[data-account-menu]")) toggleAccount(false);
    const ft = t.closest("[data-footer-toggle]");
    if (ft) {
      const col = ft.closest(".footer-column");
      const open = !col.classList.contains("is-open");
      $$(".footer-column.is-open").forEach((c) => { c.classList.remove("is-open"); $("[data-footer-toggle]", c).setAttribute("aria-expanded", "false"); });
      col.classList.toggle("is-open", open);
      ft.setAttribute("aria-expanded", open);
    }
  });

  /* Predictive search: brands + products, like the live overlay. */
  const searchInput = $("[data-search-input]");
  if (searchInput) {
    let timer;
    searchInput.addEventListener("input", () => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        const q = searchInput.value.trim();
        const box = $("[data-search-results]");
        if (q.length < 2) { box.hidden = true; return; }
        try {
          const r = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`);
          const data = await r.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
          const items = products.map((p) => `<li><a href="${esc(p.url)}" class="grid min-h-16 grid-cols-[48px_1fr_auto] items-center gap-3 py-2">${p.image ? `<img src="${esc(p.image)}&width=96" alt="" width="48" height="60" class="h-14 w-12 object-cover">` : "<span></span>"}<span><bdi dir="ltr" class="block text-sm font-semibold">${esc(p.vendor)}</bdi><span class="block text-sm text-stone">${esc(String(p.title).replace(p.vendor, "").trim())}</span></span><span class="text-sm">₪${Math.round(Number(p.price)).toLocaleString("en-US")}</span></a></li>`).join("");
          box.innerHTML = `<p class="mt-5 text-sm text-stone">מוצרים</p>${items ? `<ul class="mt-3 divide-y divide-line">${items}</ul>` : `<div class="py-8 text-center"><p class="text-sm font-semibold">לא נמצאו מוצרים או מותגים</p><p class="mt-2 text-sm text-stone">נסו שם מותג או מונח כללי יותר.</p></div>`}<button type="submit" class="mt-4 flex min-h-11 w-full items-center justify-center border-t border-line text-sm underline">לכל התוצאות עבור “${esc(q)}”</button>`;
          box.hidden = false;
        } catch (_) { /* keep the plain form */ }
      }, 180);
    });
  }

  /* ---------------- announcement bar ---------------- */
  const ann = $("[data-announcement]");
  if (ann) {
    const track = $("[data-announcement-track]", ann);
    const n = track.children.length - 1;
    let i = 0, paused = false;
    // Shrink a message that does not fit on one line (narrow phones, enlarged system text).
    const fit = () => $$(":scope > div", track).forEach((d) => {
      d.style.fontSize = "";
      for (let px = parseFloat(getComputedStyle(d).fontSize); d.scrollWidth > d.clientWidth && px > 10; px -= 0.5) d.style.fontSize = `${px - 0.5}px`;
    });
    fit();
    addEventListener("resize", fit);
    document.fonts?.ready.then(fit);
    const go = (to, animate = true) => {
      i = to;
      track.style.transition = animate && !reduced() ? "transform 500ms ease-out" : "none";
      track.style.transform = `translate3d(${-i * 100}%,0,0)`;
      $$(":scope > div", track).forEach((d, k) => d.setAttribute("aria-hidden", k !== i));
      $("[data-announcement-live]", ann).textContent = track.children[i % n].textContent;
      // The last slide is a copy of the first: after sliding onto it, jump back to the real first.
      clearTimeout(wrap);
      if (i === n && animate) wrap = setTimeout(() => go(0, false), 520);
    };
    let wrap;
    $("[data-announcement-next]", ann).addEventListener("click", () => go(Math.min(i + 1, n)));
    $("[data-announcement-prev]", ann).addEventListener("click", () => {
      if (i > 0) return go(i - 1);
      go(n, false);
      requestAnimationFrame(() => requestAnimationFrame(() => go(n - 1)));
    });
    ann.addEventListener("mouseenter", () => (paused = true));
    ann.addEventListener("mouseleave", () => (paused = false));
    setInterval(() => { if (!paused) go(Math.min(i + 1, n)); }, reduced() ? 7000 : 5000);
  }

  /* ---------------- wishlist (local, per device) ---------------- */
  const WL = "pp-wishlist";
  const readWl = () => { try { return JSON.parse(localStorage.getItem(WL) || "[]"); } catch (_) { return []; } };
  const writeWl = (v) => { try { localStorage.setItem(WL, JSON.stringify(v)); } catch (_) {} };
  function paintWl(btn, on) {
    btn.setAttribute("aria-pressed", on);
    const svg = $("svg", btn);
    if (svg) svg.setAttribute("fill", on ? "currentColor" : "none");
  }
  function bindWishlist(scope = document) {
    const list = readWl();
    $$("[data-wishlist]", scope).forEach((b) => paintWl(b, list.includes(b.dataset.wishlist)));
    const link = $("[data-wishlist-link]");
    if (link) link.hidden = !list.length;
  }
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-wishlist]");
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    let list = readWl();
    const h = b.dataset.wishlist;
    list = list.includes(h) ? list.filter((x) => x !== h) : [...list, h];
    writeWl(list);
    bindWishlist();
    document.dispatchEvent(new CustomEvent("pp:wishlist"));
  });
  bindWishlist();
  document.addEventListener("pp:tiles", () => bindWishlist());
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-inline-add]");
    if (!b) return;
    e.preventDefault();
    addToCart(b.dataset.variantId).catch(() => {});
  });

  /* ---------------- product tiles ---------------- */
  function loadSlide(span) {
    if (!span || !span.dataset.src) return;
    const img = new Image();
    img.className = "product-tile-carousel-image";
    img.src = span.dataset.src;
    img.srcset = span.dataset.srcset;
    img.sizes = "(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 420px";
    img.alt = "";
    img.width = span.dataset.w;
    img.height = span.dataset.h;
    img.decoding = "async";
    span.replaceWith(img);
  }
  function tileGo(tile, dir) {
    const track = $(".product-tile-carousel-track", tile);
    const slides = track.children;
    const idx = Math.max(0, Math.min(slides.length - 1, Number(tile.dataset.idx || 0) + dir));
    tile.dataset.idx = idx;
    loadSlide(slides[idx]);
    if (slides[idx + 1]) loadSlide(slides[idx + 1]);
    track.style.transform = `translateX(-${idx * 100}%)`;
    $(".product-tile-carousel-progress-thumb", tile).style.transform = `translateX(${idx * 100}%)`;
    $("[data-tile-prev]", tile).disabled = idx === 0;
    $("[data-tile-next]", tile).disabled = idx === slides.length - 1;
  }
  document.addEventListener("click", (e) => {
    const t = e.target;
    const nav = t.closest("[data-tile-prev],[data-tile-next]");
    if (nav) { e.preventDefault(); e.stopPropagation(); tileGo(nav.closest("[data-tile]"), nav.hasAttribute("data-tile-next") ? 1 : -1); return; }
    const qt = t.closest("[data-quick-toggle]");
    if (qt) {
      const wrap = qt.closest("[data-quick-add]");
      const open = !wrap.classList.contains("is-open");
      wrap.classList.toggle("is-open", open);
      $(".product-quick-add-overlay-panel", wrap).hidden = !open;
      qt.setAttribute("aria-expanded", open);
      return;
    }
    const qa = t.closest("[data-quick-add] [data-variant-id]");
    if (qa) {
      e.preventDefault();
      const wrap = qa.closest("[data-quick-add]");
      wrap.classList.remove("is-open");
      const panel = $(".product-quick-add-overlay-panel", wrap);
      if (panel) panel.hidden = true;
      addToCart(qa.dataset.variantId).catch(() => {});
    }
  });
  const warm = (e) => {
    const tile = e.target.closest && e.target.closest("[data-tile]");
    if (!tile || tile.dataset.warm) return;
    tile.dataset.warm = 1;
    const track = $(".product-tile-carousel-track", tile);
    if (track) loadSlide(track.children[1]);
  };
  document.addEventListener("pointerover", warm, { passive: true });
  document.addEventListener("touchstart", warm, { passive: true });
  /* Touch swipe on tile images */
  let tileTouch = null;
  document.addEventListener("touchstart", (e) => {
    const tile = e.target.closest("[data-tile]");
    if (!tile || !$(".product-tile-carousel-track", tile)) return;
    tileTouch = { tile, x: e.touches[0].clientX, y: e.touches[0].clientY };
  }, { passive: true });
  document.addEventListener("touchend", (e) => {
    if (!tileTouch) return;
    const dx = e.changedTouches[0].clientX - tileTouch.x;
    const dy = e.changedTouches[0].clientY - tileTouch.y;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) tileGo(tileTouch.tile, dx < 0 ? 1 : -1);
    tileTouch = null;
  }, { passive: true });

  /* ---------------- product page ---------------- */
  const pdp = $("[data-pdp]");
  let closeSizes = () => {};
  let closeGuide = () => {};
  if (pdp) {
    /* gallery: drag/swipe, arrows, keys, endless loop like the live Embla setup */
    const gallery = $("[data-gallery]", pdp);
    if (gallery) {
      const viewport = $(".pdp-gallery-viewport", gallery);
      const track = $(".pdp-gallery-track", gallery);
      const slides = $$(".pdp-gallery-image", track);
      const count = slides.length;
      const bar = $("[data-gallery-progress]", gallery);
      let index = 0;
      /* Seamless wrap like Embla's loop: a copy of the last slide sits before the first and a copy of the
         first after the last; after animating onto a copy the track jumps to the real slide. */
      const loop = count > 1;
      if (loop) {
        const head = slides[count - 1].cloneNode(true);
        const tail = slides[0].cloneNode(true);
        [head, tail].forEach((c) => { c.setAttribute("aria-hidden", "true"); c.removeAttribute("aria-label"); const im = $("img", c); if (im) { im.loading = "lazy"; im.removeAttribute("fetchpriority"); } });
        track.insertBefore(head, slides[0]);
        track.appendChild(tail);
      }
      const offset = loop ? 1 : 0;
      const place = (pos, animate) => {
        track.style.transition = animate && !reduced() ? "transform .45s cubic-bezier(.25,.46,.45,.94)" : "none";
        track.style.transform = `translate3d(${-pos * 100}%,0,0)`;
      };
      place(offset, false);
      let wrapTimer = null;
      const set = (i, animate = true) => {
        clearTimeout(wrapTimer);
        const target = i;
        index = (i + count) % count;
        if (loop && (target === count || target === -1) && animate && !reduced()) {
          place(target + offset, true);
          wrapTimer = setTimeout(() => place(index + offset, false), 470);
        } else {
          place(index + offset, animate);
        }
        slides.forEach((s, k) => s.setAttribute("aria-hidden", k !== index));
        if (bar) bar.style.transform = `translateX(${index * 100}%)`;
        $("[data-gallery-status]", gallery).textContent = `תמונה ${index + 1} מתוך ${count}`;
        const next = slides[(index + 1) % count];
        $("img", next)?.setAttribute("loading", "eager");
      };
      $("[data-gallery-prev]", gallery)?.addEventListener("click", () => set(index - 1));
      $("[data-gallery-next]", gallery)?.addEventListener("click", () => set(index + 1));
      gallery.addEventListener("keydown", (e) => {
        if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
        e.preventDefault();
        set(index + (e.key === "ArrowRight" ? 1 : -1));
      });
      if (count > 1) {
        let start = null;
        viewport.addEventListener("pointerdown", (e) => {
          if (e.button !== 0) return;
          start = { x: e.clientX, y: e.clientY, id: e.pointerId, moved: false };
          viewport.dataset.dragging = "true";
        });
        viewport.addEventListener("pointermove", (e) => {
          if (!start || e.pointerId !== start.id) return;
          const dx = e.clientX - start.x;
          const dy = e.clientY - start.y;
          if (!start.moved && Math.abs(dy) > Math.abs(dx)) { start = null; viewport.dataset.dragging = "false"; return; }
          if (Math.abs(dx) > 6) {
            start.moved = true;
            try { viewport.setPointerCapture(e.pointerId); } catch (_) {}
            track.style.transition = "none";
            track.style.transform = `translate3d(calc(${-(index + offset) * 100}% + ${dx}px),0,0)`;
          }
        });
        const end = (e) => {
          if (!start) return;
          const dx = e.clientX - start.x;
          const w = viewport.clientWidth;
          viewport.dataset.dragging = "false";
          if (start.moved && Math.abs(dx) > Math.min(60, w * 0.15)) set(index + (dx < 0 ? 1 : -1));
          else set(index);
          start = null;
        };
        viewport.addEventListener("pointerup", end);
        viewport.addEventListener("pointercancel", end);
      }
    }

    /* accordions (multiple open, Description open by default) */
    $$("[data-accordion-trigger]", pdp).forEach((btn) => {
      btn.addEventListener("click", () => {
        const item = btn.closest("[data-orientation].border-b");
        const open = item.dataset.state !== "open";
        const st = open ? "open" : "closed";
        item.dataset.state = st;
        btn.dataset.state = st;
        btn.parentElement.dataset.state = st;
        btn.setAttribute("aria-expanded", open);
        const region = $("[role=region]", item);
        region.dataset.state = st;
        region.hidden = !open;
      });
    });

    /* size picker: bottom sheet on phones, popover on larger screens */
    const form = $("#pdp-form", pdp);
    const trigger = $("[data-size-trigger]", pdp);
    const tpl = $("template[data-size-options]", pdp);
    const sheet = $("[data-size-sheet]", pdp);
    const pop = $("[data-size-popover]", pdp);
    const backdrop = $("[data-size-backdrop]", pdp);
    const input = $("[data-variant-input]", pdp);
    const addBtn = $("[data-add]", pdp);
    const err = $("[data-size-error]", pdp);
    const buybar = $("[data-buybar]", pdp);
    const buyBtn = $("[data-buybar-button]", pdp);
    let open = false;
    const mobile = () => matchMedia("(max-width:699px)").matches;
    const options = () => {
      const node = tpl.content.firstElementChild.cloneNode(true);
      $$("button", node).forEach((b) => b.setAttribute("aria-selected", b.dataset.variantId === input.value));
      node.addEventListener("keydown", (e) => {
        if (!["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key)) return;
        e.preventDefault();
        const bs = $$("button:not(:disabled)", node);
        const cur = bs.indexOf(document.activeElement);
        const nx = e.key === "Home" ? 0 : e.key === "End" ? bs.length - 1 : Math.max(0, Math.min(bs.length - 1, cur + (e.key === "ArrowDown" ? 1 : -1)));
        bs[nx]?.focus();
      });
      return node;
    };
    const placePopover = () => {
      const r = trigger.getBoundingClientRect();
      pop.style.left = `${r.left + scrollX}px`;
      pop.style.top = `${r.bottom + scrollY + 8}px`;
      pop.style.width = `${r.width}px`;
      pop.style.maxHeight = `${Math.max(160, innerHeight - r.bottom - 24)}px`;
    };
    const openSizes = () => {
      if (open) return;
      open = true;
      trigger.setAttribute("aria-expanded", "true");
      trigger.dataset.state = "open";
      if (mobile()) {
        $(".pdp-size-options", sheet)?.remove();
        sheet.appendChild(options());
        backdrop.hidden = false;
        sheet.hidden = false;
        lock();
        setTimeout(() => $(".pdp-size-options button:not(:disabled)", sheet)?.focus(), 30);
      } else {
        pop.innerHTML = "";
        pop.appendChild(options());
        document.body.appendChild(pop);
        placePopover();
        pop.hidden = false;
        setTimeout(() => $("button:not(:disabled)", pop)?.focus(), 30);
      }
    };
    closeSizes = (focus = true) => {
      if (!open) return;
      open = false;
      trigger.setAttribute("aria-expanded", "false");
      trigger.dataset.state = "closed";
      if (!sheet.hidden) { sheet.hidden = true; backdrop.hidden = true; unlock(); }
      pop.hidden = true;
      if (focus) trigger.focus();
    };
    const choose = (b) => {
      input.value = b.dataset.variantId;
      const label = b.dataset.label;
      $("[data-size-label]", trigger).textContent = label;
      trigger.setAttribute("aria-label", `מידה ${label}`);
      trigger.setAttribute("aria-invalid", "false");
      err.hidden = true;
      $$("[data-price]", pdp).forEach((p) => (p.textContent = b.dataset.priceText));
      const ap = $("[data-add-price]", pdp);
      if (ap) ap.textContent = b.dataset.priceText;
      if (buyBtn) buyBtn.textContent = "הוספה לסל";
      closeSizes();
    };
    trigger.addEventListener("click", () => (open ? closeSizes() : openSizes()));
    [sheet, pop].forEach((c) => c.addEventListener("click", (e) => {
      const b = e.target.closest(".pdp-size-options button");
      if (b && !b.disabled) choose(b);
      if (e.target.closest("[data-size-close]")) closeSizes();
    }));
    backdrop.addEventListener("click", () => closeSizes());
    document.addEventListener("pointerdown", (e) => {
      if (open && !pop.hidden && !pop.contains(e.target) && !trigger.contains(e.target)) closeSizes(false);
    });
    addEventListener("resize", () => closeSizes(false));

    /* size guide drawer */
    const guide = $("[data-size-guide]", pdp);
    const gback = $("[data-guide-backdrop]", pdp);
    const gbtn = $("[data-size-guide-open]", pdp);
    const openGuide = () => { gback.hidden = false; guide.hidden = false; gbtn.setAttribute("aria-expanded", "true"); lock(); setTimeout(() => $(".pdp-round-close", guide)?.focus(), 30); };
    closeGuide = () => { if (guide.hidden) return; gback.hidden = true; guide.hidden = true; gbtn.setAttribute("aria-expanded", "false"); unlock(); gbtn.focus(); };
    gbtn.addEventListener("click", openGuide);
    gback.addEventListener("click", closeGuide);
    $("[data-guide-close]", guide).addEventListener("click", closeGuide);
    guide.addEventListener("click", (e) => { if (e.target.closest("a[href]")) closeGuide(); });

    /* add to cart */
    let adding = false;
    const add = async () => {
      if (adding || addBtn.disabled) return;
      if (!input.value) {
        err.hidden = false;
        trigger.setAttribute("aria-invalid", "true");
        trigger.focus();
        $("[data-buy]", pdp).scrollIntoView({ behavior: reduced() ? "auto" : "smooth", block: "center" });
        return;
      }
      adding = true;
      const label = $("[data-add-label]", addBtn);
      label.textContent = "נוסף לסל";
      addBtn.disabled = true;
      if (buyBtn) { buyBtn.textContent = "נוסף לסל"; buyBtn.disabled = true; }
      try { await addToCart(input.value, 1); } catch (_) { label.textContent = "לא ניתן להוסיף כרגע"; }
      setTimeout(() => {
        adding = false;
        addBtn.disabled = false;
        label.textContent = "הוספה לסל";
        if (buyBtn) { buyBtn.disabled = false; buyBtn.textContent = "הוספה לסל"; }
      }, 500);
    };
    form.addEventListener("submit", (e) => { e.preventDefault(); add(); });

    /* mobile buy bar: visible until the real add button is fully on screen */
    if (buybar && "IntersectionObserver" in window) {
      const io = new IntersectionObserver(([entry]) => {
        const show = entry.intersectionRatio < 1 && entry.boundingClientRect.top > 0;
        buybar.dataset.show = show;
        buybar.setAttribute("aria-hidden", !show);
      }, { threshold: 1 });
      io.observe(addBtn);
      buyBtn.addEventListener("click", () => {
        if (input.value) return add();
        $("[data-buy]", pdp).scrollIntoView({ behavior: reduced() ? "auto" : "smooth", block: "center" });
        setTimeout(openSizes, 400);
      });
    }

    /* desktop: sticky info panel follows the viewport once its bottom is visible */
    const info = $("[data-pdp-info]", pdp);
    const header = $(".site-header .header-row");
    const measure = () => {
      const top = Math.min(header ? header.getBoundingClientRect().height : 70, innerHeight - info.offsetHeight - 24);
      info.style.setProperty("--pdp-sticky-top", `${top}px`);
    };
    if ("ResizeObserver" in window) new ResizeObserver(measure).observe(info);
    addEventListener("resize", measure);
    measure();

    /* recommendations (Shopify product recommendations API) */
    const rec = $("[data-recommendations]", pdp);
    if (rec) {
      const load = async () => {
        try {
          const r = await fetch(rec.dataset.url);
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, "text/html");
          const section = $(".pdp-recommendations", doc);
          if (!section) return;
          rec.replaceWith(section);
          bindWishlist(section);
          const rail = $("[data-rec-rail]", section);
          const move = (d) => rail.scrollBy({ left: d * rail.clientWidth, behavior: reduced() ? "auto" : "smooth" });
          $("[data-rec-prev]", section).addEventListener("click", () => move(-1));
          $("[data-rec-next]", section).addEventListener("click", () => move(1));
        } catch (_) {}
      };
      if ("IntersectionObserver" in window) {
        const io = new IntersectionObserver((entries) => { if (entries.some((x) => x.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: "600px" });
        io.observe(rec);
      } else load();
    }
  }

  /* ---------------- collection ---------------- */
  let closeFilters = () => {};
  const coll = $("[data-collection]");
  if (coll) {
    const sortWrap = $("[data-sort]", coll);
    const sortBtn = $("[data-sort-toggle]", coll);
    const sortList = $("[data-sort-list]", coll);
    sortBtn?.addEventListener("click", () => {
      const o = sortList.hidden;
      sortList.hidden = !o;
      sortBtn.setAttribute("aria-expanded", o);
    });
    document.addEventListener("pointerdown", (e) => { if (sortList && !sortWrap.contains(e.target)) { sortList.hidden = true; sortBtn.setAttribute("aria-expanded", "false"); } });
    sortList?.addEventListener("click", (e) => {
      const b = e.target.closest("[data-sort-value]");
      if (!b) return;
      const url = new URL(location.href);
      url.searchParams.set("sort_by", b.dataset.sortValue);
      url.searchParams.delete("page");
      location.href = url.toString();
    });

    const drawerEl = $("[data-filters]", coll);
    const back = $(".collection-filters-backdrop", coll);
    const openFilters = () => { drawerEl.classList.add("is-open"); back.classList.add("is-open"); drawerEl.inert = false; lock(); $("[data-filters-open]", coll).setAttribute("aria-expanded", "true"); };
    closeFilters = () => { if (!drawerEl || !drawerEl.classList.contains("is-open")) return; drawerEl.classList.remove("is-open"); back.classList.remove("is-open"); drawerEl.inert = true; unlock(); $("[data-filters-open]", coll).setAttribute("aria-expanded", "false"); };
    $("[data-filters-open]", coll)?.addEventListener("click", openFilters);
    $$("[data-filters-close]", coll).forEach((b) => b.addEventListener("click", closeFilters));
    $$("[data-facet-toggle]", coll).forEach((b) => b.addEventListener("click", () => {
      const panel = document.getElementById(b.getAttribute("aria-controls"));
      const o = panel.dataset.open !== "true";
      panel.dataset.open = o;
      panel.inert = !o;
      b.setAttribute("aria-expanded", o);
    }));

    /* load more: fetch the next page and append its tiles */
    coll.addEventListener("click", async (e) => {
      const more = e.target.closest("[data-load-more]");
      if (!more) return;
      e.preventDefault();
      more.setAttribute("aria-busy", "true");
      try {
        const r = await fetch(more.href);
        const doc = new DOMParser().parseFromString(await r.text(), "text/html");
        const grid = $("[data-grid]", coll);
        $$("[data-grid] > *", doc).forEach((n) => grid.appendChild(document.importNode(n, true)));
        bindWishlist(grid);
        const nextMore = $("[data-load-more]", doc);
        const shown = $("[data-shown]", doc)?.textContent;
        $$("[data-shown]", coll).forEach((s) => (s.textContent = shown));
        if (nextMore) more.href = nextMore.href;
        else $("[data-load-more-wrap]", coll)?.remove();
        more.removeAttribute("aria-busy");
      } catch (_) { location.href = more.href; }
    });
  }
})();
